<template>
  <div>
    <ServiceRequestCreate ref="serviceRequestCreate" :policy="policy" :serviceRequestType="serviceRequestKey" :initialID="ID" :shouldGetFields="false">
      <div slot="serviceRequestType" slot-scope="row">
        <b-row v-for="rider in existedRiders">
          <b-col cols="6">
            <FITAutoSearch v-model="rider.product" @input="onProductChanged(rider, $event)" :label="getLabel('riderProduct')" dest="option" :paras="[{ key: 'type', value: 'life' }]" :showItems="['productEnglishName', 'productChineseName']" :width="columnWidth" :disabled="rider.disabled || row.isLocked"></FITAutoSearch>
          </b-col>
          <b-col cols="4">
            <FITTextInput :width="8" v-model="rider.riderPremium" @input="onRiderPremiumChanged(rider, $event)" :label="getLabel('riderPremium')" type="number" :disabled="rider.disabled || row.isLocked"></FITTextInput>
          </b-col>
          <b-col  cols="2">
            <FITButton :accessLevel="3.5" :text="getLabel('removeRider')" faIcon="fa-times-circle" variant="danger" @click="removeRider(rider)" v-if="!rider.disabled" :disabled="row.isLocked"></FITButton>
            <FITButton :text="getLabel('recoverRider')" faIcon="fa-recycle" variant="warning" @click="recoverRider(rider.ID)" v-if="rider.disabled" :disabled="row.isLocked"></FITButton>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <FITButton :accessLevel="3.5" variant="warning" :text="getLabel('newRider')" faIcon="fa-plus-circle" @click="addNewRider" :disabled="row.isLocked"></FITButton>
          </b-col>
        </b-row>
        <b-row v-for="(rider, index) in newRiders">
          <b-col cols="6">
            <FITAutoSearch :rule="{required:true}" field="riderProduct" v-model="rider.product" @input="onProductChanged(index, $event, true)" :label="getLabel( 'riderProduct') " dest="option" :disabled="row.isLocked" :paras="[{ key: 'type', value: 'life' }]" :showItems="[ 'productEnglishName', 'productChineseName']" :width="columnWidth"></FITAutoSearch>
          </b-col>
          <b-col cols="4">
            <FITTextInput :rule="{required:true, decimal:true}" field="riderPremium" :width="8" v-model="newRiders[index].riderPremium" :label="getLabel( 'riderPremium')" type="number" :disabled="row.isLocked"></FITTextInput>
          </b-col>
          <b-col cols="2">
            <FITButton :text="getLabel('removeRider')" faIcon="fa-times-circle" variant="danger" @click="removeRider(index, true)" :disabled="row.isLocked"></FITButton>
          </b-col>
        </b-row>
      </div>
    </ServiceRequestCreate>
  </div>
</template>
<script type="text/javascript">
import ServiceRequestCreate from '../ServiceRequestCreate'

import {
  FITTextInput,
  FITButton,
  FITAutoSearch,
  FITSelect,
  FITTextarea,
  FITDatePicker
} from '@/components'

import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
export default {
  name: 'ChangeRider',
  components: {
    ServiceRequestCreate,
    FITTextInput,
    FITButton,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea
  },

  methods: {
    onProductChanged(rider, product, isNewRider) {
      if (isNewRider && product) {
        Vue.set(this.newRiders[rider], 'productID', product.ID)
        return
      }

      let riderID = rider.ID

      let index = this.existedRiders.map((item) => item.ID).indexOf(riderID);
      if (index === -1) {
        return
      }

      Vue.set(this.existedRiders[index], 'productID', product.ID)

      // 
      index = this.form.filter((item) => { return (item['ID'] !== null) })
        .map((item) => item['ID'])
        .indexOf(riderID);

      if (index !== -1) { // existed
        Vue.set(this.form[index], 'productID', product.ID)
      } else {
        this.form.push({
          ID: riderID,
          productID: product.ID,
          riderPremium: rider.riderPremium
        })
      }
    },

    onRiderPremiumChanged(rider, amount) {
      let riderID = rider.ID

      let index = this.existedRiders.map((item) => item.ID).indexOf(riderID);
      if (index === -1) {
        return
      }

      Vue.set(this.existedRiders[index], 'riderPremium', rider.riderPremium)

      // 
      index = this.form.filter((item) => { return (item['ID'] !== null) })
        .map((item) => item['ID'])
        .indexOf(riderID);

      if (index !== -1) { // existed
        Vue.set(this.form[index], 'riderPremium', rider.riderPremium)
      } else {
        this.form.push({
          ID: riderID,
          productID: rider.productID,
          riderPremium: rider.riderPremium
        })
      }
    },

    addNewRider() {
      this.newRiders.push({
        productID: null,
        riderPremium: 0,
        product: {
          ID: -1,
          productEnglishName: '',
          productChineseName: ''
        }

      })
    },

    removeRider(rider, isNewRider) {

      let riderID = rider.ID

      if (isNewRider) {
        let newRiders = this.newRiders;
        newRiders.splice(riderID, 1)
        Vue.set(this, 'newRiders', newRiders)
      } else {
        let index = this.form
          .filter((item) => { return (item['ID'] !== null) })
          .map((item) => item['ID'])
          .indexOf(riderID)

        if (index !== -1) { // existed
          Vue.set(this.form[index], 'version', 0)
        } else {
          this.form.push({
            ID: riderID,
            productID: rider.productID,
            riderPremium: rider.riderPremium
          })
        }

        Vue.set(this.existedRiders[index], 'disabled', true);
      }
    },

    recoverRider(riderID) {
      let index = this.form
        .filter((item) => { return (item['ID'] !== null) })
        .map((item) => item['ID'])
        .indexOf(riderID)

      if (index !== -1) { // existed
        delete this.form[index]['version']
        // Vue.set(this.form[index], 'version', 0)
      }

      Vue.set(this.existedRiders[index], 'disabled', false);
    },

    getLabel(field) {
      return this.$t(`osm.serviceRequest.type.${this.serviceRequestKey}.${field}`);
    },

    // setRowStatus(riderID, enable) {
    //   let dom = this.$refs[`rider-${riderID}`];
    //   if (dom) {
    //     r
    //     dom.disabled = true;
    //     this.$refs[`rider-${riderID}-productID`].disabled = !enable
    //     this.$refs[`rider-${riderID}-riderPremium`].disabled = !enable
    //     this.$refs[`rider-${riderID}-removeRider`].disabled = !enable

    //     this.$refs[`rider-${riderID}-recoverRider`].disabled = enable
    //   }
    // }
  },

  data() {
    return {
      type: {},
      form: [],
      newRiders: [],
      serviceRequestKey: 'CRI',
      existedRiders: []
    }
  },

  props: {
    ID: {
      type: Number,
      default: null
    },

    policy: {
      type: Object,
      default: () => {
        return {
          policyID: 92,
          policyType: 'P'
        }
      }
    }
  },

  computed: {
 
    columnWidth() {
      // if (this.$refs.serviceRequestCreate) {
      //   return this.$refs.serviceRequestCreate.option.data.column;
      // }
      return 10;
    },

    ...mapGetters('ServiceRequest', [
      'getTranslated',
      'getTranslatedArray',
      'getTranslatedString',
      'isValueModified',
      'getServiceRequestTranslated'
    ]),

    ...mapState('ServiceRequest', [
      'fields',
      'selectedType'
    ]),

    combine() {
      let existing = JSON.parse(
        JSON.stringify(
          this.form
          .filter((item) => {
            return item.ID && item.ID > 0
          })
        ))

      let newRiders = JSON.parse(JSON.stringify(this.newRiders))
        .filter((item) => {
          return item.productID && item.productID > 0
        })
        .map((item) => {
          var param = {}

          Object.keys(item).forEach((key) => {
            if (key !== 'product') {
              param[key] = item[key]
            }
          })

          return param
        })
      let form = existing.concat(newRiders)
      return form;
    }

  },

  created() {
    if (!this.policy) {
      console.debug(this.serviceRequestKey, 'Null policy ID when routing to service request');
      return
    }

    this.$store.dispatch('ServiceRequest/getRiderFields', {
        policyID: this.policy.policyID
      })
      .then((json) => {

        if (!this.ID) {
          // Emit current data, assuming new service request
          return
        }

        this.$store
          .dispatch('ServiceRequest/getServiceRequestDetail', {
            ID: this.ID
          })
          .then((json) => {
            this.$refs.serviceRequestCreate.setLocked(true)
            // this.$emit('onLockedChanged', true);
            // Service Request ID is provided, retrieve and emit parameter from service request.
            // Parameters should be string originally
            // this.$emit('onDataRetrived', JSON.parse(json.data.parameter))
          })
          .catch((err) => {
            console.error(err);
          })
        // this.selectedType.list
        //   .forEach((column) => {
        //     Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
        //   })
      })
      .catch((err) => {

      })
  },

  watch: {
    newRiders: {
      deep: true,
      handler(val) {
        this.$store.commit({
          type: 'ServiceRequest/setTypeForm',
          form: this.combine
        })
      }
    },

    form: {
      deep: true,
      handler(val) {
        this.$store.commit({
          type: 'ServiceRequest/setTypeForm',
          form: this.combine
        })
      }
    },

    'selectedType.list': {
      deep: true,
      handler(val) {
        Vue.set(this, 'existedRiders',
          JSON.parse(JSON.stringify(val))
          .map((item) => {
            item['disabled'] = false
            item['product'] = {
              ID: -1,
              productEnglishName: '',
              productChineseName: ''
            }
            return item;
          }))

        this.existedRiders.forEach((r, index) => {

          this.$store.dispatch('searchOption', {
              searchInput: { ID: r.productID },
              optionType: 'life',
              dest: 'option'
            })
            .then((response) => {
              let product = response[0]
              if (product) {
                product['disabled'] = r['disabled']
                Vue.set(this.existedRiders[index], 'product', product)
              }
            })

        })
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestTypes/ChangeRider.vue